import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";


export function useLocationQuery() {
    const history = useHistory();
    return useMemo(() => Object.fromEntries(new URLSearchParams(history.location.search)), [history.location.search])
}